export const noop = () => {};
export const noopStr = () => '';
